import React from 'react';

import { AlertSwitcher } from './AlertSwitcher/AlertSwitcher';
import { AlertTextfield } from './AlertTextfield/AlertTextfield';

export const AlertSetting = ({ onChange, onToggle, value, checked, type, label }) => (
    <>
        <AlertSwitcher label={label} checked={checked} switcherType={type} toggleHandler={onToggle} />
        {checked && <AlertTextfield value={value} timerType={type} changeHandler={onChange} />}
    </>
);
